import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconCircle: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#00795B',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM14.188 16.25H9.81299C8.52199 16.25 7.75098 15.479 7.75098 14.188V9.81299C7.75098 8.52099 8.52199 7.75098 9.81299 7.75098H14.188C15.479 7.75098 16.25 8.52199 16.25 9.81299V14.188C16.25 15.479 15.479 16.25 14.188 16.25ZM9.81201 9.25C9.34901 9.25 9.25 9.35001 9.25 9.81201V14.187C9.25 14.649 9.35001 14.749 9.81201 14.749H14.187C14.65 14.749 14.749 14.649 14.749 14.187V9.81201C14.749 9.35001 14.649 9.25 14.187 9.25H9.81201Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconCircle;
